import { render, staticRenderFns } from "./EditarVacante.vue?vue&type=template&id=0c9e4a9e&scoped=true"
import script from "./EditarVacante.vue?vue&type=script&lang=js"
export * from "./EditarVacante.vue?vue&type=script&lang=js"
import style0 from "./EditarVacante.vue?vue&type=style&index=0&id=0c9e4a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9e4a9e",
  null
  
)

export default component.exports